export const getPaymentUrl = (): string => "/payment/invoke";
export const getPaymentStatusUrl = (): string => "/payment/status";
export const getZeroPaymentUrl = (): string => "/payment/zeroinvoke";
export const getStoreProxyUrl = (): string => "/store";
